export default __webpack_public_path__ + "static/media/d5.adde3c89.jpg";